export default __webpack_public_path__ + "static/media/layer07.64880d55.png";